<template>
  <div class="main-body">
    <div class="header">综合配置</div>
    <div class="out">

      <div style="background-color: #fff;" :style="th">

        <div style="float: left;width: 50%;background-color: #eee;" :style="th">

          <div style="margin-right: 5px;">
            <div style="padding: 20px;border-bottom: 0.5px solid #ddd;background-color: #fff;">
              <div style="float:left;">科室绩效分值占比：目标量{{govInfo.departmentTargetValue}}%，关键指标{{govInfo.departmentKeyValue}}%</div>
              <div style="float:right;"><el-button type="text" style="float:right;padding: 4px;" @click="editDepartmentTargetKeyValue">编辑</el-button></div>
              <div style="clear:both;"></div>
            </div>
          </div>

          <div style="margin-right: 5px;">
            <div style="padding: 20px;border-bottom: 0.5px solid #ddd;background-color: #fff;">
              <div style="float:left;">岗位绩效分值占比：目标量{{govInfo.targetValue}}%，关键指标{{govInfo.keyValue}}%</div>
              <div style="float:right;"><el-button type="text" style="float:right;padding: 4px;" @click="editTargetKeyValue">编辑</el-button></div>
              <div style="clear:both;"></div>
            </div>
          </div>

          <div style="margin-right: 5px;">
            <div style="padding: 20px;border-bottom: 0.5px solid #ddd;background-color: #fff;">
              <div style="float:left;">科室奖金计算方式</div>
              <div style="float:right;">
                <el-switch @change="departmentRewardRatioChange"
                    v-model="govInfo.useDepartmentRewardRatio"
                    active-text="按科室系数"
                    inactive-text="按固定分配">
                </el-switch>
              </div>
              <div style="clear:both;"></div>
            </div>
          </div>

          <div style="margin-right: 5px;">
            <div style="padding: 20px;border-bottom: 0.5px solid #ddd;background-color: #fff;">
              <div style="float:left;">岗位奖金计算方式</div>
              <div style="float:right;">
                <el-switch @change="jobClassMeritsChange"
                           v-model="govInfo.useJobClassMerits"
                           active-text="按绩效得分"
                           inactive-text="按平均比例">
                </el-switch>
              </div>
              <div style="clear:both;"></div>
            </div>
          </div>


        </div>
        <div style="float: left;width: 50%;background-color: #eee;" :style="th">


          <div style="margin-left: 5px;">
            <div style="padding: 20px;border-bottom: 0.5px solid #ddd;background-color: #fff;">
              <div style="float:left;">科室收入项目模版</div>
              <div style="float:right;"><el-button type="text" style="float:right;padding: 4px;" @click="toggleModalDepartmentIncome">导出</el-button></div>
              <div style="clear:both;"></div>
            </div>
          </div>
          <div style="margin-left: 5px;">
            <div style="padding: 20px;border-bottom: 0.5px solid #ddd;background-color: #fff;">
              <div style="float:left;">科室工作数据模版</div>
              <div style="float:right;"><el-button type="text" style="float:right;padding: 4px;" @click="toggleModalDepartmentWork">导出</el-button></div>
              <div style="clear:both;"></div>
            </div>
          </div>
          <div style="margin-left: 5px;">
            <div style="padding: 20px;border-bottom: 0.5px solid #ddd;background-color: #fff;">
              <div style="float:left;">科室奖金数据模版</div>
              <div style="float:right;"><el-button type="text" style="float:right;padding: 4px;" @click="getTemplateDepartmentReward">导出</el-button></div>
              <div style="clear:both;"></div>
            </div>
          </div>

          <div style="margin-left: 5px;">
            <div style="padding: 20px;border-bottom: 0.5px solid #ddd;background-color: #fff;">
              <div style="float:left;">岗位收入项目模版</div>
              <div style="float:right;"><el-button type="text" style="float:right;padding: 4px;" @click="toggleModalJobClassIncome">导出</el-button></div>
              <div style="clear:both;"></div>
            </div>
          </div>
          <div style="margin-left: 5px;">
            <div style="padding: 20px;border-bottom: 0.5px solid #ddd;background-color: #fff;">
              <div style="float:left;">岗位工作数据模版</div>
              <div style="float:right;"><el-button type="text" style="float:right;padding: 4px;" @click="toggleModalJobClassWork">导出</el-button></div>
              <div style="clear:both;"></div>
            </div>
          </div>




        </div>
        <div style="clear: both"></div>

      </div>

    </div>


    <DepartmentIncome ref="myDepartmentIncome" v-show="showModalDepartmentIncome" v-on:closeDepartmentIncome="closeDepartmentIncome" v-on:setDepartmentIncome="setDepartmentIncome"></DepartmentIncome>
    <DepartmentWork ref="myDepartmentWork" v-show="showModalDepartmentWork" v-on:closeDepartmentWork="closeDepartmentWork" v-on:setDepartmentWork="setDepartmentWork"></DepartmentWork>

    <JobClassIncome ref="myJobClassIncome" v-show="showModalJobClassIncome" v-on:closeJobClassIncome="closeJobClassIncome" v-on:setJobClassIncome="setJobClassIncome"></JobClassIncome>
    <JobClassWork ref="myJobClassWork" v-show="showModalJobClassWork" v-on:closeJobClassWork="closeJobClassWork" v-on:setJobClassWork="setJobClassWork"></JobClassWork>

    <TargetKeyValue ref="myTargetKeyValue" v-show="showModalTargetKeyValue" v-on:closeTargetKeyValue="closeTargetKeyValue" v-on:getGovInfo="getGovInfo"></TargetKeyValue>
    <DepartmentTargetKeyValue ref="myDepartmentTargetKeyValue" v-show="showModalDepartmentTargetKeyValue" v-on:closeDepartmentTargetKeyValue="closeDepartmentTargetKeyValue" v-on:getGovInfo="getGovInfo"></DepartmentTargetKeyValue>

    <div v-if="showModal" class="mask">
      <div class="lodingsIcon">
        <i class="el-icon-loading"></i>
        <span>正在处理，请等待。。。</span>
      </div>
    </div>

  </div>
</template>

<script>

import DepartmentIncome from "./DepartmentIncome";
import DepartmentWork from "./DepartmentWork";

import JobClassIncome from "./JobClassIncome";
import JobClassWork from "./JobClassWork";

import TargetKeyValue from "./TargetKeyValue";
import DepartmentTargetKeyValue from "./DepartmentTargetKeyValue";

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: "Main",

  data(){
    return{

      showModalDepartmentIncome:false,
      showModalDepartmentWork:false,

      showModalJobClassIncome:false,
      showModalJobClassWork:false,

      showModalTargetKeyValue:false,
      showModalDepartmentTargetKeyValue:false,

      showModal:false,

      th:'',

      govInfo:{
        governmentInfoCode:'',
        targetValue:'',
        keyValue:'',
        useDepartmentRewardRatio:'',
        useJobClassMerits:'',
      },

    }
  },
  created(){

    this.getGovInfo();

    this.th = "height:"+(this.$store.state.tableHeight+100)+"px";
  },
  components:{
    DepartmentIncome,DepartmentWork,
    JobClassIncome,JobClassWork,
    TargetKeyValue,DepartmentTargetKeyValue
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = "height:"+(val+100)+"px";
    },
  },
  methods:{


    //科室收入项目
    toggleModalDepartmentIncome:function(){
      this.showModalDepartmentIncome = !this.showModalDepartmentIncome;
      this.$refs.myDepartmentIncome.init();
    },
    closeDepartmentIncome:function(){
      this.showModalDepartmentIncome = !this.showModalDepartmentIncome;
    },
    setDepartmentIncome(row){
      this.getTemplateDepartmentIncome(row.departmentCode);
    },
    getTemplateDepartmentIncome(departmentCode){

      this.showModal = true;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'BaseSet/ExportTemplateDepartmentIncome',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          departmentCode:departmentCode,
        }
      }).then( (response)=> {
        //console.log(response);

        this.showModal = false;

        if(response.data.error == 0){

          let path = response.data.data.path;
          window.open(this.$imgUrl+path,"_blank");

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },


    //科室工作
    toggleModalDepartmentWork:function(){
      this.showModalDepartmentWork = !this.showModalDepartmentWork;
      this.$refs.myDepartmentWork.init();
    },
    closeDepartmentWork:function(){
      this.showModalDepartmentWork = !this.showModalDepartmentWork;
    },
    setDepartmentWork(row){
      this.getTemplateDepartmentWork(row.departmentCode);
    },
    getTemplateDepartmentWork(departmentCode){

      this.showModal = true;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'BaseSet/ExportTemplateDepartmentKey',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          departmentCode:departmentCode,
        }
      }).then( (response)=> {
        //console.log(response);

        this.showModal = false;

        if(response.data.error == 0){

          let path = response.data.data.path;
          window.open(this.$imgUrl+path,"_blank");

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },






    //岗位收入项目
    toggleModalJobClassIncome:function(){
      this.showModalJobClassIncome = !this.showModalJobClassIncome;
      this.$refs.myJobClassIncome.init();
    },
    closeJobClassIncome:function(){
      this.showModalJobClassIncome = !this.showModalJobClassIncome;
    },
    setJobClassIncome(row){
      this.getTemplateJobClassIncome(row.jobClassCode);
    },
    getTemplateJobClassIncome(jobClassCode){

      this.showModal = true;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'BaseSet/ExportTemplateJobClassIncome',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          jobClassCode:jobClassCode,
        }
      }).then( (response)=> {
        //console.log(response);

        this.showModal = false;

        if(response.data.error == 0){

          let path = response.data.data.path;
          window.open(this.$imgUrl+path,"_blank");

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },


    //岗位工作
    toggleModalJobClassWork:function(){
      this.showModalJobClassWork = !this.showModalJobClassWork;
      this.$refs.myJobClassWork.init();
    },
    closeJobClassWork:function(){
      this.showModalJobClassWork = !this.showModalJobClassWork;
    },
    setJobClassWork(row){
      this.getTemplateJobClassWork(row.jobClassCode);
    },
    getTemplateJobClassWork(jobClassCode){

      this.showModal = true;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'BaseSet/ExportTemplateJobClassKey',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          jobClassCode:jobClassCode,
        }
      }).then( (response)=> {
        //console.log(response);

        this.showModal = false;

        if(response.data.error == 0){

          let path = response.data.data.path;
          //console.log(path);

          window.open(this.$imgUrl+path,"_blank");

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },




    editTargetKeyValue:function(){
      this.showModalTargetKeyValue = !this.showModalTargetKeyValue;
      this.$refs.myTargetKeyValue.init(this.govInfo);
    },
    closeTargetKeyValue(){
      this.showModalTargetKeyValue = !this.showModalTargetKeyValue;
    },
    editDepartmentTargetKeyValue:function(){
      this.showModalDepartmentTargetKeyValue = !this.showModalDepartmentTargetKeyValue;
      this.$refs.myDepartmentTargetKeyValue.init(this.govInfo);
    },
    closeDepartmentTargetKeyValue(){
      this.showModalDepartmentTargetKeyValue = !this.showModalDepartmentTargetKeyValue;
    },




    //科室奖金模版
    getTemplateDepartmentReward(){

      this.showModal = true;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'BaseSet/ExportTemplateDepartmentReward',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then( (response)=> {
        //console.log(response);

        this.showModal = false;

        if(response.data.error == 0){

          let path = response.data.data.path;
          window.open(this.$imgUrl+path,"_blank");

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },


    getGovInfo(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'BaseSet/GovInfo',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then( (response)=> {
        //console.log(response);

        if(response.data.error == 0){
          this.govInfo = response.data.data.governmentInfo;

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },
    departmentRewardRatioChange(val){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'BaseSet/EditDepartmentRewardRatio',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          useDepartmentRewardRatio:val,
        }
      }).then( (response)=> {
        //console.log(response);

        if(response.data.error == 0){
          this.getGovInfo();

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });


    },
    jobClassMeritsChange(val){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'BaseSet/EditJobClassMerits',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          useJobClassMerits:val,
        }
      }).then( (response)=> {
        //console.log(response);

        if(response.data.error == 0){
          this.getGovInfo();

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },


  }
}
</script>

<style scoped>
.mask {
  background-color: rgb(0, 0, 0);
  opacity: 0.3;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 199
}
.mask .lodingsIcon{
  /* margin-top: 47vh; */
  margin: 47vh auto;
  height: 6vh;
  width: 300px;
  font-size: 18px;
  color: white;
}
.mask.lodingsIcon i{
  z-index: 200;
  font-size: 25px;
  margin-right:10px ;
}
</style>
